import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ErrorCode } from '../utils/apiError';
import { ErrorDescription } from './Forms';

const translateErrorCode = new Map([
  [ErrorCode.COMPANY_ALREADY_EXISTS, 'FORM_FILL_COMPANY.VERIFICATION_FAILED'],
  [ErrorCode.COMPANY_EXTERNAL_VERIFICATION_FAILED, 'FORM_FILL_COMPANY.COMPANY_EXTERNAL_VERIFICATION_FAILED'],
]);

const VerificationInformation = ({ errorCode }) => {
  const { t } = useTranslation();

  return (
    <>
      <ErrorDescription>
        {t(translateErrorCode.get(errorCode))}
      </ErrorDescription>
    </>
  );
};

export default VerificationInformation;

VerificationInformation.propTypes = {
  errorCode: PropTypes.oneOf(Object.values(ErrorCode)).isRequired,
};
